import reactTextareaAutosize from 'react-textarea-autosize';

import { ChannelSettingSectionHeader } from './ChannelSettingSectionHeader';
import { Switch } from '@frontend/components/ui/switch';
import { Textarea } from '@frontend/components/ui/textarea';

export function ChannelSettingToggleTextarea({
  title,
  description,
  isEnabled,
  value,
  onToggle,
  onValueChange,
  placeholder,
  minRows = 3,
  isReadOnly = false,
  helperText,
}: {
  title: string;
  description: string;
  isEnabled: boolean;
  value: string;
  onToggle: (enabled: boolean) => void;
  onValueChange: (value: string) => void;
  placeholder?: string;
  minRows?: number;
  isReadOnly?: boolean;
  helperText?: string;
}) {
  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <ChannelSettingSectionHeader title={title} description={description} />
        <Switch
          checked={isEnabled}
          disabled={isReadOnly}
          onCheckedChange={(checked) => !isReadOnly && onToggle(checked)}
        />
      </div>

      {isEnabled && (
        <div>
          <Textarea
            // @ts-expect-error - reactTextareaAutosize typing issue
            as={reactTextareaAutosize}
            value={value}
            className="text-sm leading-[21px]"
            minRows={minRows}
            disabled={isReadOnly}
            onChange={(e) => !isReadOnly && onValueChange(e.target.value)}
            placeholder={placeholder}
          />
          {helperText && (
            <p className="mt-2 text-xs text-gray-500">{helperText}</p>
          )}
        </div>
      )}
    </div>
  );
}
